/**
 * @file Created on Wed Aug 08 2018
 * @author PKl
 */
import FormGroupInline from './styled/FormGroupInlineStyled';
export default FormGroupInline;